import React, { useState, useEffect, useRef } from 'react';
import SignaturePadModalCanvas from 'react-signature-canvas';
import styled from 'styled-components';
import RESET from '../../resources/icon/reset.png'
import {uploadImageSign} from "../../api/file/FileService";
import {apiLoading, refresh} from "../../redux/slice/apiSlice";
import {useDispatch} from "react-redux";

const CanvasWrapper = styled.div`
    position: relative;
    background: #ecedee;
    width: 450px;
    height: 220px;
    border: 1px solid gray;
    margin: auto;
`;

const CanvasPlaceholder = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
`;

const SignaturePadModal = ({user, opener, setter, onSave, onUploaded}) => {
    const dispatch = useDispatch();
    const canvasRef = useRef(null);
    const [signatureData, setSignatureData] = useState('');

    const [isSigned, setIsSigned] = useState(false);

    const save = () => {
        if (!canvasRef.current) {
            return;
        }

        const dataURL = canvasRef.current.getTrimmedCanvas().toDataURL('image/png');
        setSignatureData(dataURL);
        const signBlob = dataURItoBlob(dataURL);

        if (onSave) {
            onSave(dataURL, signBlob);
            setter?.(dataURL);
            alert("등록되었습니다.");
            opener(false);
            return;
        }

        dispatch(apiLoading(true));
        uploadImageSign(user.id, user.name, signBlob).then((response) => {
            if (response.status === 200) {
                setter?.(dataURL);
                onUploaded?.();
                alert("등록에 성공했습니다.");
                opener(false);
            } else {
                alert("등록에 실패했습니다.");
            }
        }).finally(() => dispatch(apiLoading(false)));
    };



    function dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    }

    return (
        <>
        <div className={'drawer-background show'} onClick={()=>opener(false)}></div>
            <div className={`signature-container`}>
                <button
                    className={`mt-[70px] mb-[20px]`}
                    onClick={() => {
                        canvasRef.current.clear(); // 리셋
                        setIsSigned(false);
                    }}
                >
                    <img src={RESET} className={'w-[20px] inline'}/> 초기화
                </button>
                <CanvasWrapper>
                    {!isSigned && (
                        <CanvasPlaceholder>
                            여기에 서명을 해주세요.
                        </CanvasPlaceholder>
                    )}
                    <SignaturePadModalCanvas
                        canvasProps={{
                            className: 'signature-canvas',
                            width: 450,
                            height: 220,
                        }}
                        ref={canvasRef}
                        onBegin={() => {
                            setIsSigned(true);
                        }}
                    />
                </CanvasWrapper>

                <button
                    className={`signature-save-button ${isSigned? 'bg-[var(--main-bg-color)] text-white':'bg-[var(--odd-background)] text-black'}`}
                    disabled={!isSigned}
                    onClick={() => save()}
                >
                    저장
                </button>
            </div>
        </>
    );
};

export default SignaturePadModal;